<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="changeOrderSubmissionDateModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId"
         aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Zmień datę zlecenia zamówienia</h5>

            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="error" class="alert alert-danger" role="alert">
              {{ error }}
            </div>

            <div class="col-md-12 col-lg-3">
              <label for="project-select">Wybierz datę zlecenia zamówienia</label>
              <ejs-datepicker
                  :weekNumber="true"
                  format="dd.MM.yyyy"
                  :placeholder="'Wybierz datę'"
                  :value="newSelectedDate"
                  @change="onDateChange"
              ></ejs-datepicker>
            </div>

            <div class="table-responsive mt-5">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th>Nr poz.</th>
                  <th> Podzespół nr rysunku</th>
                  <th>Nr katalogowy</th>
                  <th>Model</th>
                  <th>Nazwa/Opis</th>
                  <th>Ilość wymagana</th>
                  <th>Ilość magazynowa</th>
                  <th>Status</th>
                  <th>Status Mag</th>
                  <th>Data zlecenia zamówienia</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="record in selectedRecords">
                  <td>{{ record.id }}</td>
                  <td>{{ record.subteam_drawing_no }}</td>
                  <td>{{ record.article?.catalog_number || '' }}</td>
                  <td>{{ record.article.model }}</td>
                  <td>{{ record.article.description }}</td>
                  <td>{{ record.quantity_required }}</td>
                  <td>{{ record.article_main_warehouse?.quantity }}</td>
                  <td>{{ record.status }}</td>
                  <td>{{ record.inventory_status?.name }}</td>
                  <td>{{ formatDate(record.order_submission_date) }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              <i class="bi bi-x-square me-2"></i>Zamknij
            </button>

            <form @submit.prevent="submitForm">
              <button type="submit" class="btn btn-primary">
                <i class="bi bi-save me-2"></i>Zapisz
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {Modal} from "bootstrap";
import {DatePickerComponent} from "@syncfusion/ej2-vue-calendars";

let dropInstanceFilterUnits, delivererElem, multiSelectObj;

export default {
  components: {
    "ejs-datepicker": DatePickerComponent,
  },

  props: {
    selectedRecords: Object,
    statuses: Object
  },

  data() {

    return {
      newSelectedDate: null,
      error: null,
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
			  this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
    this.$emit('clear-selection');
  });
  },

  methods: {
    formatDate(dateString) {
      if (!dateString)
        return '';

      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są od 0 do 11, więc dodajemy 1
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    onDateChange(args) {
      this.newSelectedDate = args.value;
    },

    submitForm() {
      let record_ids = this.selectedRecords.map(item => ({id: item.id}));
      axios.post(route('requiredProjectItems.change-order-submission-date', {
            records: record_ids,
            newReleaseDate: this.newSelectedDate
          }
      )).then(() => {
        this.$emit('added-success', 'Zmieniono datę zwolnienia poprawnie');
        this.$emit('updated-article');
		this.$emit('clear-selection');
        this.hide();
      }).catch(error => {
        this.error = error.response.data
        console.log('error', error);
      });
    },

    show() {
      if (this.modalObj) {
        this.modalObj.show();
      }
    },
    hide() {
      if (this.modalObj) {
        this.modalObj.hide();
      }
    },
  }
}

</script>

<style scoped>

</style>